export function applyOztixUtm(url) {
    if (!url) return url;
    if (!url.includes("oztix.com.au")) return url;
    try {
        const u = new URL(url.startsWith("http") ? url : "https://" + url);
        u.search = "";
        u.searchParams.set("utm_source", "Hotgiggity");
        u.searchParams.set("utm_medium", "gig_guide_app");
        return u.toString();
    } catch (e) {
        return url;
    }
}
